import { render, staticRenderFns } from "./PairedTrades.vue?vue&type=template&id=73c6779c&scoped=true&"
import script from "./PairedTrades.vue?vue&type=script&lang=js&"
export * from "./PairedTrades.vue?vue&type=script&lang=js&"
import style0 from "./PairedTrades.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PairedTrades.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PairedTrades.vue?vue&type=style&index=2&id=73c6779c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c6779c",
  null
  
)

export default component.exports